const homeAnim = {
  isMobileOrTablet() {
    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      ) || navigator.maxTouchPoints > 2
    );
  },

  init() {
    document.addEventListener("DOMContentLoaded", () => {
      const cursor = document.querySelector(".blob-agence");
      /* const imageWrappers = document.querySelectorAll('.image-wrapper');
      const images = Array.from(imageWrappers).map(w => w.querySelector('img')); */

      /* GSAP ANIMATIONS */
      //Smooth content
      let smoother = ScrollSmoother.create({
        wrapper: "#smooth-container",
        content: "#smooth-content",
        smooth: 0.7,
        effects: false,
      });


      // N'appliquer les effets du curseur que si ce n'est pas un mobile/tablette
      if (!this.isMobileOrTablet()) {
        // 2. Suivi de la souris avec throttle à 60fps (~16.67ms)
        const root = document.documentElement;
        const smoothContent = document.querySelector("#smooth-content");
        let mx = -9999,
          my = -9999,
          rafId = 0,
          lastUpdateTime = 0;
        const THROTTLE_INTERVAL = 1000 / 60; // ~16.67ms pour 60fps

        function apply() {
          // Mettre à jour les variables CSS pour tous les éléments .glow-border
          const glowBorders = document.querySelectorAll(".glow-border");

          glowBorders.forEach((element) => {
            element.style.setProperty(
              "--mx",
              mx - element.getBoundingClientRect().left,
            );
            element.style.setProperty(
              "--my",
              my - element.getBoundingClientRect().top,
            );
          });

          // Mettre à jour le cursor blob avec les coordonnées correctes
          if (cursor) {
            // Récupérer le décalage Y du smooth-content
            const scrollOffset = gsap.getProperty("#smooth-content", "y") || 0;
            gsap.to(cursor, {
              x: mx - 25,
              y: my - 25 - scrollOffset,
              duration: 0,
              overwrite: false,
            });
          }

          rafId = 0;
          lastUpdateTime = performance.now();
        }

        function move(e) {
          // Utilise les coordonnées de la souris par rapport au viewport
          mx = e.clientX;
          my = e.clientY;
          const now = performance.now();
          if (!rafId && now - lastUpdateTime >= THROTTLE_INTERVAL) {
            rafId = requestAnimationFrame(apply);
          }
        }

        function leave() {
          mx = -9999;
          my = -9999;
          const now = performance.now();
          if (!rafId && now - lastUpdateTime >= THROTTLE_INTERVAL) {
            rafId = requestAnimationFrame(apply);
          }
        }

        // Écoute sur window pour éviter les problèmes de capture d'événements
        window.addEventListener("pointermove", move, { passive: true });
        window.addEventListener("pointerleave", leave, { passive: true });
      }

      //
      //
      //Hero animation
      //
      //
      let tl = gsap.timeline();
      let splitHero = SplitText.create(".hero-text-description p", {
        type: "lines",
      });

      tl.from(".hero-text h1 span.side1", {
        x: "-100%",
        duration: 2,
      })
        .from(
          ".hero-text h1 span.side2",
          {
            x: "200px",
            duration: 2,
          },
          "=",
        )
        .from(
          splitHero.lines,
          {
            opacity: 0,
            x: "-200px",
            duration: 1,
            stagger: 0.3,
          },
          "-=1",
        );

      //
      //
      //Project List
      //
      //
      let projectCards = document.querySelectorAll(".project-card-container");
      const homeprojectList = document.querySelector(".project-list");

      gsap.to(projectCards, {
        scrollTrigger: {
          trigger: "#home-projects",
          start: "top 80%",
          markers: false,
        },
        width: "70%",
        duration: 2,
        delay: 2,
        stagger: 0,
      });

      gsap.to(homeprojectList, {
        scrollTrigger: {
          trigger: "#home-projects",
          start: "top 80%",
          markers: false,
        },
        gap: "2rem",
        duration: 1.5,
      });

      //glass cursor
      if (!this.isMobileOrTablet()) {
        projectCards.forEach((card, index) => {
          card.addEventListener("mouseenter", () => {
            cursor.style.opacity = "0";
          });

          card.addEventListener("mouseleave", () => {
            cursor.style.opacity = "1";
          });

          card.addEventListener("mousemove", (e) => {
            const glass = card.querySelector(".glass");
            const rect = card.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            glass.style.transform = `translate(${x - 60}px, ${y - 60}px)`;

            let xCoord = card.querySelector("#x>span");
            let yCoord = card.querySelector("#y>span");

            xCoord.innerText = e.clientX;
            yCoord.innerText = e.clientY;
          });
        });

        // Cursor effect on footer .containerr
        const containerr = document.querySelector(".containerr");
        if (containerr) {
          containerr.addEventListener("mouseenter", () => {
            cursor.style.opacity = "0";
          });

          containerr.addEventListener("mouseleave", () => {
            cursor.style.opacity = "1";
          });

          containerr.addEventListener("mousemove", (e) => {
            const circle = containerr.querySelector(".circle");
            const rect = containerr.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            // Le cercle se déplace, mais on compense le background-position pour qu'il reste fixe
            circle.style.transform = `translate(${x - 100}px, ${y - 100}px)`;
            circle.style.backgroundPosition = `calc(center - ${(x - 100)}px) calc(center - ${(y - 100)}px)`;
          });
        }
      }

      //
      //
      //Scramble text
      //
      //
      let scrambles = document.querySelectorAll(".scramble");

      scrambles.forEach((scramble) => {
        gsap.to(scramble, {
          scrollTrigger: {
            trigger: scramble,
            start: "-100px 80%",
          },
          scrambleText: {
            rightToLeft: true,
            chars: "upperCase",
          },
          duration: 1,
        });
      });

      //
      // Split Text
      //

      let splits = document.querySelectorAll(".split");
      splits.forEach((splitElement) => {
        let split = SplitText.create(splitElement, { type: "lines" });

        gsap.from(split.lines, {
          scrollTrigger: {
            trigger: splitElement,
            start: "-100px 80%",
          },
          duration: 1,
          x: -100,
          autoAlpha: 0,
          stagger: 0.5,
        });
      });

      //
      //Parallax
      //
      if (!this.isMobileOrTablet()) {
        let img = document.querySelector(".presentation-img");

        gsap.fromTo(
          img,
          {
            y: "0vh",
          },
          {
            y: "-20vh",

            scrollTrigger: {
              markers: false,
              trigger: img,
              scrub: true,
              start: "top 80%", // position of trigger meets the scroller position
            },
            ease: "none",
          },
        );
      }
      //
      // Images Présentation 2
      //
      if (!this.isMobileOrTablet()) {
        let image1 = document.querySelector(
          "#presentation-2 .image-container:first-child div:first-child",
        );
        let image2 = document.querySelector(
          "#presentation-2 .image-container:first-child div:last-child",
        );

        let image3 = document.querySelector(
          "#presentation-2 .image-container:last-of-type div:first-child",
        );
        let image4 = document.querySelector(
          "#presentation-2 .image-container:last-of-type div:last-child",
        );

        gsap.from(image1, {
          scrollTrigger: {
            trigger: "#presentation-2",
            start: "50% 80%",
            markers: false,
            scrub: true,
            end: "80% 50%",
          },
          x: -100,
        });

        gsap.from(image2, {
          scrollTrigger: {
            trigger: "#presentation-2",
            start: "50% 80%",
            markers: false,
            scrub: true,
            end: "50% 50%",
          },
          y: -100,
        });

        gsap.from(image3, {
          scrollTrigger: {
            trigger: "#presentation-2",
            start: "70% 80%",
            markers: false,
            scrub: true,
            end: "80% 50%",
          },
          y: 100,
        });

        gsap.from(image4, {
          scrollTrigger: {
            trigger: "#presentation-2",
            start: "70% 80%",
            markers: false,
            scrub: true,
            end: "80% 0%",
          },
          x: 100,
        });
      }
      //
      //Clients Logo
      //

      document.querySelectorAll(".clients-logos-item").forEach((item) => {
        let recto = item.querySelector("img.recto");
        let verso = item.querySelector("img.verso");

        // Initialisation : premier logo visible, second invisible
        gsap.set(verso, { opacity: 0 });

        // Timeline pour cette paire de logos
        let tl = gsap.timeline({ repeat: -1 });

        // Affiche le premier logo, attend un délai aléatoire, puis passe au second
        tl.to(recto, { opacity: 1, duration: 0 })
          .to({}, { duration: gsap.utils.random(3, 6) }) // Attend 2-5s
          .to(recto, { opacity: 0, duration: 0.5 })
          .to(verso, { opacity: 1, duration: 0.5 })
          .to({}, { duration: gsap.utils.random(3, 6) }) // Attend 2-5s
          .to(verso, { opacity: 0, duration: 0.5 });
      });

      // SCROLL TO TOP BUTTON
      const scrollToTopBtn = document.getElementById("scroll-to-top");
      if (scrollToTopBtn) {
        window.addEventListener("scroll", () => {
          if (window.scrollY > 300) {
            scrollToTopBtn.classList.add("visible");
          } else {
            scrollToTopBtn.classList.remove("visible");
          }
        });

        scrollToTopBtn.addEventListener("click", () => {
          ScrollSmoother.get().scrollTo(0, true);
        });
      }

      // LIENS ANCRES

      // après avoir initialisé ScrollSmoother
      /* if (window.location.hash) {
        const id = window.location.hash.slice(1);
        const target = document.getElementById(id);
        if (target) {
          const smoother = ScrollSmoother.get();
          if (smoother) {
            smoother.scrollTo(target, true, "top top");
          } else {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      }

      let heroBtn = document.querySelector(".hero-btn");
      heroBtn.addEventListener("click", (e) => {
        e.preventDefault();
        let target = document.querySelector(heroBtn.getAttribute("href"));
        ScrollSmoother.get().scrollTo(target, true, "center center");
      });

      // Sélectionne tous les liens dans le menu et le footer
      const checkSmoother = setInterval(() => {
        if (typeof ScrollSmoother !== "undefined" && ScrollSmoother.get()) {
          clearInterval(checkSmoother);

          // Sélectionne tous les liens dans le menu et le footer
          const menuLinks = document.querySelectorAll(
            '.topmenu-container a[href*="#"], footer a[href*="#"]',
          );
          menuLinks.forEach((link) => {
            link.addEventListener("click", function (e) {
              // only intercept links that point to an anchor on the *current* page
              const href = this.getAttribute("href");
              if (!href) return;

              // build a URL to compare pathnames even when href is relative
              const url = new URL(href, window.location.origin);
              if (url.pathname !== window.location.pathname) {
                // different page, allow normal navigation
                return;
              }

              e.preventDefault();

              // extract the anchor id and scroll to it
              const targetId = url.hash.replace("#", "");
              if (!targetId) return;

              const target = document.getElementById(targetId);
              if (!target) return;

              const smoother = ScrollSmoother.get();
              if (smoother) {
                smoother.scrollTo("#" + targetId, true, "top top");
              } else {
                target.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            });
          });
        }
      }, 100); // Vérifie toutes les 100ms */

      // Skills Accordion for Mobile
      const skillNames = document.querySelectorAll(".skill-name");
      const skills = document.querySelectorAll(".skill");

      skillNames.forEach((skillName) => {
        skillName.addEventListener("click", (e) => {
          const skill = skillName.closest(".skill");
          const isActive = skill.classList.contains("active");

          // Close all skills
          skills.forEach((s) => s.classList.remove("active"));

          // Toggle current skill
          if (!isActive) {
            skill.classList.add("active");
          }
        });
      });

      // Project List Drag Functionality
      const projectList = document.querySelector(".project-list");
      if (projectList) {
        let isDown = false;
        let startX;
        let scrollLeft;

        projectList.addEventListener("mousedown", (e) => {
          isDown = true;
          projectList.style.cursor = "grabbing";
          startX = e.pageX - projectList.offsetLeft;
          scrollLeft = projectList.scrollLeft;
          e.preventDefault();
          e.stopPropagation();
        });

        projectList.addEventListener("mouseleave", () => {
          isDown = false;
          projectList.style.cursor = "grab";
        });

        projectList.addEventListener("mouseup", () => {
          isDown = false;
          projectList.style.cursor = "grab";
        });

        projectList.addEventListener("mousemove", (e) => {
          if (!isDown) return;
          e.preventDefault();
          e.stopPropagation();
          const x = e.pageX - projectList.offsetLeft;
          const walk = (x - startX) * 1;
          projectList.scrollLeft = scrollLeft - walk;
        });
      }
    });
  },
};

export default homeAnim;
